import React from "react";
import { useAppContext } from "@qlik/qlik/src/context/AppContext";

const PricingFeatureTableHeaderCard = ({ data }) => {
    const { title, eyebrowText } = data;
    const { currency } = useAppContext();

    const splitTitleArray = title?.split("|").map((item) => item.trim());
    let initPlanPrice = "";
    let plan = "";
    let planOverview = "";

    if (splitTitleArray?.length === 2) {
        initPlanPrice = splitTitleArray[0];
        plan = splitTitleArray[1];
    } else if (splitTitleArray?.length === 1) {
        plan = splitTitleArray[0];
    }

    const planPricesArray = initPlanPrice.split(":")?.map((item) => item.trim());
    planOverview = planPricesArray?.[0];

    if (splitTitleArray && currency) {
        const formattedPlanPrice =
            planPricesArray[currency?.id] && planPricesArray[currency?.id] !== ""
                ? planPricesArray[currency?.id]
                : planPricesArray[0];
        planOverview = `${formattedPlanPrice} ${plan}`;
    }

    return (
        <div className="header-card px-2.5 pt-2.5 pb-5">
            <div className="rounded p-3.75 text-left bg-light-casper">
                {eyebrowText && <span className="block tag-2 uppercase">{eyebrowText}</span>}
                {title && (
                    <div className="title-4 pt-2.5" suppressHydrationWarning={true}>
                        {planOverview}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PricingFeatureTableHeaderCard;
